export default class FilterToggle {
    constructor() {
        this.toggle = document.querySelector(".js-filters-toggle");
        this.form = document.querySelector(".js-filters-form");

        if (!this.toggle || !this.form) {
            return;
        }

        this.labelOpen = this.toggle.dataset.labelOpen;
        this.labelClose = this.toggle.dataset.labelClose;

        this.toggleForm = this.toggleForm.bind(this);

        this._setDOMReferences();
    }

    _setDOMReferences() {
        this.toggle.addEventListener("click", () => this.toggleForm());
    }

    toggleForm() {
        if (this.form.classList.contains("is--open")) {
            this.form.classList.remove("is--open");
            if (this.labelClose) {
                this.toggle.innerHTML = this.labelClose;
            }
        } else {
            this.form.classList.add("is--open");
            if (this.labelOpen) {
                this.toggle.innerHTML = this.labelOpen;
            }
        }
    }
}
